import { z } from 'zod';
import { bloodPressureValidation } from '../shared/blood-pressure-validation';
export const baseVitals = z.object({
    notChecked: z.boolean().optional(),
    weight: z.string().optional(),
    height: z.string().optional(),
    temp: z.string().optional(),
    via: z.string().optional(),
});
export const baseVitalsRefined = baseVitals.refine((data) => data.notChecked || data.weight?.trim() || data.height?.trim() || data.temp?.trim() || data.via?.trim(), {
    message: 'At least one answer is required',
    path: [],
});
export const baseO2 = z.object({
    notChecked: z.boolean().optional(),
    o2Sat: z.string().optional(),
    inr: z.string().optional(),
    flow: z.string().optional(),
});
export const baseO2Refined = baseO2.refine((data) => data.notChecked || data.o2Sat?.trim() || data.inr?.trim() || data.flow?.trim(), {
    message: 'At least one answer is required',
    path: [],
});
export const basePulse = z.object({
    notChecked: z.boolean().optional(),
    pulse: z.string().optional(),
    pulseApical: z.string().optional(),
    pulseReg: z.string().optional(),
    resp: z.string().optional(),
    respReg: z.string().optional(),
});
export const basePulseRefined = basePulse.refine((data) => data.notChecked ||
    data.pulse?.trim() ||
    data.pulseApical?.trim() ||
    data.pulseReg?.trim() ||
    data.resp?.trim() ||
    data.respReg?.trim(), {
    message: 'At least one answer is required',
    path: [],
});
export const baseBloodSugar = z.object({
    notChecked: z.boolean().optional(),
    am: z.string().optional(),
    pm: z.string().optional(),
    noon: z.string().optional(),
    hs: z.string().optional(),
});
export const baseBloodSugarRefined = baseBloodSugar.refine((data) => data.notChecked || data.am?.trim() || data.pm?.trim() || data.noon?.trim() || data.hs?.trim(), {
    message: 'At least one answer is required',
    path: [],
});
export const baseBloodPressure = z.object({
    notChecked: z.boolean().optional(),
    bloodPressures: z
        .array(z.object({
        systolic: z.string().optional(),
        diastolic: z.string().optional(),
        position: z.string().optional(),
        arm: z.string().optional(),
    }))
        .optional(),
});
export const baseBloodPressureRefined = bloodPressureValidation('notChecked', {
    checkboxLabel: 'Not Captured',
});
export const Vitals = {
    vitals: {
        version: ['e1'],
        timepoint: ['soc', 'roc', 'dsch'],
    },
    o2: {
        version: ['e1'],
        timepoint: ['soc', 'tr', 'trd', 'dsch'],
    },
    pulseRespiration: {
        version: ['e1'],
        timepoint: ['soc', 'tr', 'trd', 'dsch'],
    },
    bloodSugar: {
        version: ['e1'],
        timepoint: ['soc', 'tr', 'trd', 'dsch'],
    },
    bloodPressure: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
};
